import React from "react";
import Select from "react-select";

/**
 * The project's select.
 *
 * The theme styles react-select through `classNamePrefix="react-select"`
 * (assets/css/sass/plugins/react-select.scss), so this keeps that contract and
 * adds a plain-value API — callers pass and receive the value itself rather
 * than assembling { label, value } objects at every call site.
 */
const toOption = (option) => {
  if (option === null || option === undefined) return null;
  if (typeof option === "object") return option;
  return { label: String(option), value: option };
};

const SelectInput = ({
  value,
  onChange,
  options = [],
  placeholder = "Select…",
  isDisabled = false,
  isClearable = false,
  isMulti = false,
  name,
  className = "",
  ...rest
}) => {
  const normalised = options.map(toOption).filter(Boolean);

  const selected = isMulti
    ? normalised.filter((option) => (value || []).includes(option.value))
    : normalised.find((option) => option.value === value) ?? null;

  const handleChange = (picked) => {
    if (isMulti) return onChange((picked || []).map((option) => option.value));
    return onChange(picked ? picked.value : "");
  };

  return (
    <Select
      name={name}
      className={`react-select ${className}`.trim()}
      classNamePrefix="react-select"
      options={normalised}
      value={selected}
      onChange={handleChange}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isClearable={isClearable}
      isMulti={isMulti}
      menuPlacement="auto"
      {...rest}
    />
  );
};

export default SelectInput;
